import { Formik, Form } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import withResetLink from "components/ResetLink";
import { AuthInputField } from "components/formfields";
import { CodeValidationSchema } from "utils/Validation";

const VerifyPhoneForm = ({
  time,
  resetLink,
  startTimer,
  onClose,
  handleVerificationError,
}) => {
  const [code, setCode] = useState("");

  const resendCode = async () => {
    resetLink();
  };

  const handleCode = async (input) => {
    if (time !== "00:00") {
      if (input === "1234") {
        toast.success("Phone number is verified");
        handleVerificationError(true, "");
        onClose();
      } else {
        toast.error("Invalid");
        handleVerificationError(false, "Phone number is not verified");
      }
    } else {
      toast.error("Code has expired!");
    }
  };

  useEffect(() => {
    startTimer();
  }, []);

  return (
    <Formik
      initialValues={{ verificationCode: "" }}
      validationSchema={CodeValidationSchema("2FA")}
    >
      {({}) => (
        <Form className="flex flex-col gap-5">
          <AuthInputField
            length={4}
            onChange={(input) => {
              setCode(input);
              if (input.length === 4) {
                handleCode(input);
              }
            }}
            value={code}
          />
          <div className="w-full flex flex-col items-center gap-2">
            {time === "00:00" ? (
              <>
                <div className="text-red-500">
                  Authentication Code has been expired!
                </div>
                <div
                  onClick={() => {
                    resendCode();
                  }}
                  className=" text-sm font-semibold flex items-center text-secondary hover:underline hover:cursor-pointer"
                >
                  Send again?
                </div>
              </>
            ) : (
              <span className="mx-auto text-lg mt-6 font-semibold flex items-center text-secondary">
                {time}
              </span>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default withResetLink(VerifyPhoneForm);
